/**
 * Created by shubham on 11/4/18.
 */

/**
 * A model for an individual corporate employee
 */
export class AdminDashboardList {
    id:number;
    Name: string;
    roleName: string;
    email: string;
    emailVerified: boolean;
    businessUnits: any;
    userId_WPASS: string;
    pendingSubUserCount: string;
    languageId: string;
    languageName: string;
    countryId: string;
    countryName: string;
    companyName: string;
    companyAddress: string;
    companyPhone: string;
    personalArea: string;
    costCenter: string;
    location: string;
    contractorType: string;
    actionFlag: boolean;
    status: string;
    appStatus: boolean;
    createdAt: string;

    constructor(id:number, Name:string, roleName:string, email:string, emailVerified:boolean, businessUnits:any, userId_WPASS:string, pendingSubUserCount:string,
                languageId:string, languageName: string, countryId: string, countryName: string, companyName: string, companyAddress: string, companyPhone: string,
                personalArea: string, costCenter: string, location: string, actionFlag:boolean, contractorType: string, status: string, appStatus: boolean, createdAt: string){
        this.id = id;
        this.Name = Name;
        this.roleName = roleName;
        this.email = email;
        this.emailVerified = emailVerified;
        this.businessUnits = businessUnits;
        this.userId_WPASS = userId_WPASS;
        this.pendingSubUserCount = pendingSubUserCount;
        this.languageId = languageId;
        this.languageName = languageName;
        this.countryId = countryId;
        this.countryName = countryName;
        this.companyName = companyName;
        this.companyAddress = companyAddress;
        this.companyPhone = companyPhone;
        this.personalArea = personalArea;
        this.costCenter = costCenter;
        this.location = location;
        this.contractorType = contractorType;
        this.actionFlag = actionFlag;
        this.status = status;
        this.appStatus = appStatus;
        this.createdAt = createdAt;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-dashboard/admin-datatable/admin-dashboardList.ts